import { useMutation } from '@tanstack/react-query';

import { EOperationTypes } from '~/shared/enums/EOperationTypes';

import { sendOperationDocumentByEmail } from '../api';

export function useSendOperationDocumentByEmail() {
  return useMutation({
    mutationFn: (operationType: EOperationTypes) =>
      sendOperationDocumentByEmail(operationType)
  });
}
